import { render, staticRenderFns } from "./chooseTask.vue?vue&type=template&id=0fdc97c0&scoped=true"
import script from "./chooseTask.vue?vue&type=script&lang=js"
export * from "./chooseTask.vue?vue&type=script&lang=js"
import style0 from "./chooseTask.vue?vue&type=style&index=0&id=0fdc97c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc97c0",
  null
  
)

export default component.exports